import { USER_LEVEL_KEY, type Loose } from '~/api/interface'

enum SPACE_MAP {
  TEMPLATE, // 模板
  STUDIO, // 场景
  PERSON, // 人物
  MEDIA, // 媒体
  // SOURCE, // 资源
}

enum MEDIA_MAP {
  MATERIAL, // 素材
  OPENING_AND_ENDING, // 片头片尾
  TEXT_TEMPLATE, // 文字模板
  PASTER, // 贴片
  FONT, // 字体
}

export enum FILE_TYPE_MAP {
  IMAGE = 0, // 图片
  BACKGROUND_IMAGE, // 背景图
  AUDIO = 2, // 音频
  VIDEO = 3, // 视频
  PAG = 10, // PAG
  PPT = 11, // PPT
  PDF = 12, // PDF
  FONT = 13, // FONT
}

const MEDIA_TYPE_MAP = () => {
  const { $t } = useNuxtApp()
  return <Loose>{
    [FILE_TYPE_MAP.IMAGE]: $t('tu-pian'),
    [FILE_TYPE_MAP.VIDEO]: $t('shi-pin'),
    [FILE_TYPE_MAP.PPT]: 'PPT',
    [FILE_TYPE_MAP.PDF]: 'PDF',
  }
}

// 0=未付款，1=已付款，2=交易关闭，3=已退款，4=支付失败，5=已撤销，6=支付中，7=交易结束，不可退款,99已付款(权益过期)
enum ORDER_STATUS {
  UNPAID = 0,
  PAID = 1,
  CLOSED = 2,
  REFUNDED = 3,
  FAILED = 4,
  REVOKED = 5,
  IN = 6,
  END = 7,
  EXPIRED = 99,
}

// enum ORDER_TYPE {
//   UNPAID = 0,
//   PAID = 1,
//   CLOSED = 2,
//   REFUNDED = 3,
//   FAILED = 4,
//   REVOKED = 5,
//   IN = 6,
//   END = 7
// }
// 收藏来源
export enum COLLECTION_SOURCE {
  PERSON = 0, // 个人空间
  TEAM = 1, // 团队空间
  SHARE = 2, // 与我分享
  YOUYAN = 3, // 有言平台
  RECENTLY = 4, // 最近作品
}

const COLLECTION_SOURCE_MAP = () => {
  const { $t } = useNuxtApp()
  return {
    [COLLECTION_SOURCE.PERSON]: $t('ge-ren-kong-jian'),
    [COLLECTION_SOURCE.TEAM]: $t('tuan-dui-kong-jian'),
    [COLLECTION_SOURCE.SHARE]: $t('yu-wo-fen-xiang'),
    [COLLECTION_SOURCE.YOUYAN]: $t('you-yan-ping-tai'),
  }
}

// 前端展示资源类型
enum UPLOAD_TYPE {
  PERSON, // 个人空间上传
  TEAM, // 团队空间上传
  BRAND, // 品牌上传
}

// 收藏、空间一级分类
export enum COLLECTION_MAP {
  OPUS, // 作品
  PIECES, // 成片
  PIECES_TEMPLATE, // 成片模板
  SOURCE, // 资源
  RECYCLING_BIN, // 回收站
}

// 前端展示资源类型
export enum RESOURCE_TYPE {
  STUDIO = 2, // 场景
  PERSON = 1, // 人物
  TIMBRE = 3, // 音色
  SUBTITLE_TEMPLATE = 4, // 字幕模板
  TEXT_TEMPLATE = 8, // 文字模板
  MATERIAL = 0, // 素材
  FONT = 6, // 字体
  MUSIC = 7, // 音乐
  SOUND_EFFECT = 11, // 音效
  PASTER = 9, // 贴纸
  HEAD = 5, // 片头
  END = 13, // 片尾
  MIX_TEXT_TEMPLATE = 22, // 前端动静态文字模板
  TEMPLATE = 10086,
}

const RESOURCE_TYPE_NAME_TRANSLATE = () => {
  const { $t } = useNuxtApp()
  return <Record<RESOURCE_TYPE, string>>{
    [RESOURCE_TYPE.STUDIO]: $t('chang-jing'), // 场景
    [RESOURCE_TYPE.PERSON]: $t('ren-wu'), // 人物
    [RESOURCE_TYPE.TIMBRE]: $t('yin-se'), // 音色
    [RESOURCE_TYPE.SUBTITLE_TEMPLATE]: $t('zi-mu-mo-ban'), // 字幕模板
    [RESOURCE_TYPE.TEXT_TEMPLATE]: $t('wen-zi-mo-ban'), // 文字模板
    [RESOURCE_TYPE.MATERIAL]: $t('su-cai'), // 素材
    [RESOURCE_TYPE.FONT]: $t('zi-ti'), // 字体
    [RESOURCE_TYPE.MUSIC]: $t('yin-le'), // 音乐
    [RESOURCE_TYPE.SOUND_EFFECT]: $t('yin-xiao'), // 音效
    [RESOURCE_TYPE.PASTER]: $t('tie-zhi'), // 贴纸
    [RESOURCE_TYPE.HEAD]: $t('pian-tou'), // 片头
    [RESOURCE_TYPE.END]: $t('pian-wei'), // 片尾
    [RESOURCE_TYPE.MIX_TEXT_TEMPLATE]: $t(
      'qian-duan-dong-jing-tai-wen-zi-mo-ban'
    ), // 前端动静态文字模板
  }
}

// 后端资源类型
enum RESOURCE_TYPE_CONFIG {
  MATERIAL, // 素材
  PERSON, // 人物
  STUDIO, // 场景
  TIMBRE, // 音色
  SUBTITLE_TEMPLATE, // 字幕模板
  AE_PAG_TEMPLATE_HEAD, // 片头
  FONT, // 字体
  MUSIC, // 音乐
  STATIC_TEXT_TEMPLATE, // 静态文字模板
  PASTER, // 贴纸
  SOUND_EFFECT = 11, // 音效
  DYNAMIC_TEXT_TEMPLATE, // 动态文字模板
  AE_PAG_TEMPLATE_TAIL, // 片尾
}

// 板式
enum PLATE_TYPE {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

const PLATE_TYPE_MAP = () => {
  const { $t } = useNuxtApp()
  return {
    [PLATE_TYPE.VERTICAL]: { label: $t('shu-ping'), key: '1080x1920' },
    [PLATE_TYPE.HORIZONTAL]: { label: $t('heng-ping'), key: '1920x1080' },
  }
}

const RECYCLING_BIN_MAP = () => {
  const { $t } = useNuxtApp()
  return [
    { label: $t('zuo-pin'), key: COLLECTION_MAP.OPUS },
    { label: $t('cheng-pian'), key: COLLECTION_MAP.PIECES },
    { label: $t('cheng-pian-mo-ban'), key: COLLECTION_MAP.PIECES_TEMPLATE },
    { label: $t('zi-yuan'), key: COLLECTION_MAP.SOURCE },
  ]
}

const RESOURCE_TYPE_MAP = () => {
  const { $t } = useNuxtApp()
  return <Record<RESOURCE_TYPE | string, string>>{
    [RESOURCE_TYPE.PERSON]: $t('ren-wu'),
    [RESOURCE_TYPE.MATERIAL]: $t('su-cai'),
    [RESOURCE_TYPE.FONT]: $t('zi-ti'),
    [RESOURCE_TYPE.MUSIC]: $t('yin-le'),
    [RESOURCE_TYPE.TIMBRE]: $t('yin-se'),
    [RESOURCE_TYPE.SOUND_EFFECT]: $t('yin-xiao'),
    [RESOURCE_TYPE.PASTER]: $t('tie-zhi'),
    [RESOURCE_TYPE.HEAD]: $t('pian-tou'),
    [RESOURCE_TYPE.END]: $t('pian-wei'),
    [RESOURCE_TYPE.STUDIO]: $t('yan-bo-shi'),
  }
}

const FILE_ICON_MAP: any = {
  [FILE_TYPE_MAP.IMAGE]: 'png',
  [FILE_TYPE_MAP.BACKGROUND_IMAGE]: 'png',
  [FILE_TYPE_MAP.PPT]: 'ppt',
  [FILE_TYPE_MAP.PDF]: 'pdf',
  [FILE_TYPE_MAP.VIDEO]: 'video',
}

// 卡片类型
enum CARD_TYPE {
  MAIN, // 主卡片（适用于作品、成片、成片模板）
  MATERIAL, // 素材卡片（适用于素材、字体、片头片尾）
  MUSIC, // 音乐类卡片（适用于音乐、音频）
  PURE, // 纯图卡片（适用于贴纸）
  TIMBRE, // 音色 (含多个试听)
}

// 执行状态
enum EXECUTION_STATUS {
  NOT_STARTED,
  DATA_INIT = 3, // 初始化
  WAITING = 5,
  PROCESSING = 10,
  FINISHED = 20,
  CANCELED = 25,
  ERROR = 99,
}

// 作品渲染操作类型
enum OPUS_ACTION_TYPE {
  CANCEL = 'cancel',
  SPEED = 'speed',
  RETRY = 'retry',
  CANCEL_SPEED = 'cancelSpeed',
}

enum PAGE_TAB_TYPE {
  RECENTLY, // 最近作品
  PERSON, // 个人空间
  TEAM, // 团队空间
}

// 上传状态
enum UPLOAD_STATUS {
  FINISHED, // 成功
  UPLOADING, // 上传中
  ERROR, // 上传失败
  PROCESSING, // 处理中
  NO_START = 10, // 未开始上传
}

const STATUS_TRANSFER_MAP = () => {
  const { $t } = useNuxtApp()
  return <
    Record<
      UPLOAD_STATUS | string,
      {
        message: string
      }
    >
  >{
    [UPLOAD_STATUS.FINISHED]: {
      message: $t('shang-chuan-cheng-gong'),
    },
    [UPLOAD_STATUS.UPLOADING]: {
      message: $t('shang-chuan-zhong'),
    },
    [UPLOAD_STATUS.NO_START]: {
      message: $t('shang-chuan-zhong'),
    },
    [UPLOAD_STATUS.ERROR]: {
      message: $t('shang-chuan-shi-bai'),
    },
    [UPLOAD_STATUS.PROCESSING]: {
      message: $t('jie-xi-zhong'),
    },
  }
}
// 上传错误映射
enum REASON_MAP {
  SUCCESS = 0, // 没有错误
  INCOMPLETE = 1, // 客户端没有完成上传
  SERVER_INCOMPLETE = 2, // 服务端原因，没有完成
  RESTRICTED_SIZE = 3, // 文件大小受限
  MATERIAL_REPEAT, // 素材上传重复
  STORAGE_INSUFFICIENT, // 存储空间不足
}

// 上传错误解决办法提示
enum HINT_MAP {
  DEFAULT, // 没有错误
  UPGRADE_PERSON, // 升级到个人套餐
  UPGRADE_TEAM, // 升级到团队套餐
  BUY_STORAGE, // 请购买存储空间
  CONTACT_THE_ADMINISTRATOR, // 请联系管理员
}

// 账号注销类型
enum DELETE_TYPE {
  PERSON = 'person',
  TEAM = 'team',
}

// 发票类型
enum INVOICE_TYPE {
  NORMAL = 0, // 普通发票
  VAT = 1, // 增值税发票
}

// 开票状态
enum INVOICE_STATUS {
  SUCCESS = 1, // 已开票
  FAIL = 2, // 开票失败
  WAIT = 0, // 审核中
}

export {
  MEDIA_TYPE_MAP,
  SPACE_MAP,
  MEDIA_MAP,
  ORDER_STATUS,
  COLLECTION_SOURCE_MAP,
  PLATE_TYPE,
  PLATE_TYPE_MAP,
  RECYCLING_BIN_MAP,
  RESOURCE_TYPE_MAP,
  FILE_ICON_MAP,
  CARD_TYPE,
  RESOURCE_TYPE_CONFIG,
  EXECUTION_STATUS,
  RESOURCE_TYPE_NAME,
  UPLOAD_TYPE,
  PAGE_TAB_TYPE,
  UPLOAD_STATUS,
  REASON_MAP,
  STATUS_TRANSFER_MAP,
  HINT_MAP,
  DELETE_TYPE,
  RESOURCE_TYPE_NAME_TRANSLATE,
  INVOICE_TYPE,
  INVOICE_STATUS,
  OPUS_ACTION_TYPE,
}

export const PLACEHOLDER = getFeUrl(
  '/youyan-platform/png/placeholder.png?x-oss-process=image/format,webp'
)
export const BLACK_PLACEHOLDER = getFeUrl(
  '/youyan-platform/png/black-placeholder.png?x-oss-process=image/format,webp'
)

export const rightsNames: () => Record<USER_LEVEL_KEY, string> = () => {
  const { $t } = useNuxtApp()
  return {
    [USER_LEVEL_KEY.PERSONAL]: $t('ge-ren-ban-biao-zhun-ban'),
    [USER_LEVEL_KEY.PERSONAL_LITE]: $t('ge-ren-ru-men-ban'),
    [USER_LEVEL_KEY.TASTE]: $t('ge-ren-ti-yan-ban'),
    [USER_LEVEL_KEY.TEAM_TASTE]: $t('tuan-dui-ti-yan-ban'),
    [USER_LEVEL_KEY.TEAM_LIGHT]: $t('tuan-dui-ru-men-ban'),
    [USER_LEVEL_KEY.ORG_STANDARD]: $t('tuan-dui-biao-zhun-ban'),
    [USER_LEVEL_KEY.ORG_FLAGSHIP]: $t('tuan-dui-qi-jian-ban'),
    [USER_LEVEL_KEY.UN_AUTHORIZED]: $t('tuan-dui-wei-ren-zheng'),
  }
}

export const SAFE_HOST = [
  /youyan.xyz$/,
  /youyan3d.com$/,
  /rendora.ai$/,
  /youyan3d.bookan.com.cn$/,
  /youyan3d.magook.com$/,
  /localhost:3000$/,
  /127.0.0.1:3000$/,
]
